import { createSlice } from '@reduxjs/toolkit';
import { fetchBrandProfileList, updateBrandProfile } from './thunks';
import type { BrandProfilesSliceInitialState } from './types';

const initialState: BrandProfilesSliceInitialState = {
  brandProfilesList: [],
  loading: false,
};

const brandProfilesSlice = createSlice({
  name: 'brandProfiles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandProfileList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBrandProfileList.fulfilled, (state, action) => {
        state.loading = false;
        state.brandProfilesList = action.payload;
      })
      .addCase(fetchBrandProfileList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateBrandProfile.fulfilled, (state, action) => {
        const index = state.brandProfilesList.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.brandProfilesList[index] = action.payload;
        }
      });
  },
});

export default brandProfilesSlice.reducer;
